export default "__VITE_ASSET__vHxzv64J__"